import 'bootstrap/dist/css/bootstrap.min.css';

export default function ChapterSettings({
ChaptersEnabled,
setChaptersEnabled,
minWords,
setMinimum
})

{

    return (
        <> 
        <div className="form-check form-switch"> 
            <input type="checkbox" className="form-check-input"
            checked={ChaptersEnabled} onChange={(e)=>setChaptersEnabled(e.target.checked)}/>
            <label className="form-check-label">Rozdziały</label>
        </div>
        
        {ChaptersEnabled && (
            <div> 
                <label> Minimalna liczba słów w rozdziale </label> 
                <input className="chapterInput" type="number" value={minWords} onChange={(e)=>setMinimum(e.target.value)} />
            </div>
        )}
        </>

    )
}